export default {
  mediumHeight: { maxHeight: 750 },
  phone: { maxWidth: 768 },
  tablet: { minWidth: 769, maxWidth: 959 },
  desktop: { minWidth: 960, maxWidth: 1280 },
  uhd: { minWidth: 2500 },
}
